<div class="container-fluid InfoForm thin-scroll mt-3 py-3">
    <div *ngFor="let salesRep of salesReps ;let salesRepIndex = index">
        <div class="header  d-flex align-items-center justify-content-between p-2">
            <h6 *ngIf="salesRepIndex>0"><span class="headertxt"> Sales Rep {{salesRepIndex}} : </span></h6>
            <div *ngIf="salesRepIndex==0">
                <button (click)="showEditMode()" class="previewbtn text-center btn float-right" *ngIf="canChange">
                    <img src="../../../../../assets/shoppingCart/edit.png" class="imgIcon" />
                    <span class="mx-1 text-white"> Edit</span>

                </button>
            </div>
        </div>
        <hr class="my-2" *ngIf="salesRepIndex>0" />

        <div class="pr-3" *ngIf="salesRepIndex>0">
            <div class="row ml-1">
                <app-contact class="w-100" [isCreateOrEdit]="createOrEditSalesRepInfo" [activeTab]="activeTab"
                    [currentTab]="currentTab" [salesRepIndex]="salesRepIndex"
                    [appTransactionsForViewDto]="appTransactionsForViewDto"
                    (updateAppTransactionsForViewDto)="onUpdateAppTransactionsForViewDto($event)"
                    [showDepartment]="activeTab ==transactionCartoccordionTabs.BuyerContactInfo"
                    (formValidityChanged)="isContactFormValid($event)"></app-contact>
            </div>
        </div>

        <hr class="my-2" *ngIf="salesRepIndex>0" />
    </div>
</div>